var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _path13, _path14, _g6, _path15, _path16, _g7, _path17, _path18, _g8, _path19, _path20, _g9, _path21, _path22, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodiffiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 64,
    viewBox: "0 0 213 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 13,
    width: 7,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9424 13.7177H59.9993V20.1883H53.9424V13.7177Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 13,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6908 14.0387C57.3806 13.9606 57.0658 13.9353 56.7464 13.9583C56.427 13.9836 56.1191 14.0571 55.8227 14.1812C55.5286 14.3053 55.2597 14.473 55.0162 14.6821C54.7726 14.8935 54.5704 15.1371 54.4049 15.4128C54.359 15.5185 54.3015 15.6104 54.2533 15.7046C54.1729 15.8678 54.1154 16.0378 54.081 16.217C54.0327 16.4077 54.0051 16.6008 53.9936 16.7984C53.9845 16.996 53.9936 17.1913 54.0235 17.3866C54.0511 17.5819 54.097 17.7726 54.1637 17.9565C54.2303 18.1426 54.313 18.3218 54.4141 18.4895C54.5129 18.6596 54.6301 18.8158 54.7611 18.9629C54.8921 19.1099 55.0368 19.2409 55.1931 19.3604C55.3516 19.4776 55.5171 19.5787 55.694 19.6637C55.8709 19.7464 56.0548 19.8131 56.2455 19.8613C56.5511 19.9371 56.859 19.9624 57.1738 19.9394C57.4863 19.9165 57.7896 19.8452 58.0814 19.728C58.3709 19.6086 58.6375 19.45 58.881 19.2478C59.1223 19.0456 59.3291 18.8112 59.4968 18.547L59.7174 18.1035H59.7289C59.7864 17.9633 59.8346 17.8209 59.8668 17.6715C59.9127 17.4808 59.9403 17.2878 59.9495 17.0902C59.9587 16.8949 59.9472 16.6996 59.9173 16.5043C59.8875 16.3089 59.8392 16.1205 59.7726 15.9344C59.7059 15.7506 59.6232 15.5737 59.5221 15.4059C59.421 15.2359 59.3038 15.0796 59.1728 14.9349C59.0419 14.7878 58.8971 14.6568 58.7409 14.5396C58.5846 14.4225 58.4169 14.3214 58.2399 14.2363C58.0653 14.1536 57.8815 14.087 57.6908 14.0387Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2301 12.7392L52.7939 19.713L59.7126 21.1537L61.1464 14.1822L54.2301 12.7392Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 44,
    width: 7,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3546 44.3045H59.8252V50.7751H53.3546V44.3045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 44,
    width: 7,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4826 44.6594C57.1701 44.5813 56.8553 44.556 56.5359 44.5813C56.2165 44.6043 55.9086 44.6778 55.6145 44.8019C55.3181 44.926 55.0493 45.0937 54.8057 45.3028C54.5644 45.5142 54.3599 45.7578 54.1945 46.0335L54.0336 46.3253C53.9624 46.4908 53.905 46.6631 53.859 46.8377C53.7717 47.1847 53.7464 47.5363 53.7832 47.8924C53.8222 48.2509 53.9188 48.5886 54.0773 48.9103C54.2358 49.232 54.4426 49.5147 54.7023 49.7605C54.9619 50.0087 55.2538 50.2017 55.5823 50.3419C55.9109 50.482 56.251 50.5624 56.6072 50.5785C56.9633 50.5969 57.3103 50.551 57.6504 50.443C57.9904 50.335 58.3006 50.1718 58.5833 49.9535C58.8636 49.7329 59.1003 49.471 59.2887 49.1677C59.3691 49.0275 59.438 48.8759 59.507 48.7357H59.5185C59.5759 48.5955 59.6127 48.4577 59.6586 48.306C59.7046 48.113 59.7321 47.92 59.7413 47.7224C59.7505 47.5248 59.7413 47.3295 59.7115 47.1341C59.6816 46.9388 59.6333 46.7481 59.569 46.562C59.5024 46.3782 59.4174 46.199 59.3162 46.0312C59.2151 45.8612 59.1003 45.7049 58.967 45.5579C58.836 45.4108 58.6913 45.2798 58.535 45.1627C58.3765 45.0455 58.211 44.9444 58.0318 44.8593C57.8549 44.7743 57.671 44.7077 57.4826 44.6594Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9924 43.357L52.554 50.3492L59.5047 51.7968L60.9432 44.8046L53.9924 43.357Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 64
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H51.5898V63.5291H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 52,
    height: 65
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7794 52.1851C48.3635 52.0978 47.9476 52.1001 47.5317 52.192C47.1158 52.2839 46.7366 52.4562 46.3943 52.709C45.2339 53.5408 44.0115 54.2692 42.7293 54.8942C41.4471 55.5192 40.1213 56.0316 38.7518 56.4314C37.3847 56.8335 35.9922 57.1161 34.5768 57.2793C33.1613 57.4447 31.7413 57.4907 30.3167 57.4149L29.9123 57.3919C28.745 57.3115 27.5869 57.1529 26.4403 56.9139C12.6329 54.0371 3.76579 40.4434 6.62423 26.5579C9.48267 12.6747 22.9913 3.73865 36.7872 6.61777C40.1673 7.3163 43.2762 8.65131 46.1162 10.6228H46.1277C46.2978 10.7814 46.4816 10.9192 46.6838 11.0318C46.9549 11.1766 47.2398 11.2823 47.5409 11.3466C47.874 11.4132 48.2095 11.4224 48.5473 11.3765C48.8851 11.3282 49.2067 11.2271 49.5101 11.0709C49.8134 10.9169 50.0845 10.7147 50.3189 10.4666C50.5555 10.2184 50.7463 9.94036 50.8887 9.62787C51.0289 9.31767 51.1185 8.99138 51.1507 8.64901C51.1828 8.30664 51.1599 7.97116 51.0794 7.63569C51.0013 7.30251 50.868 6.99231 50.6842 6.70279C50.5004 6.41557 50.2729 6.16511 50.0064 5.95371H49.9949L49.7973 5.81355L49.7513 5.77908C46.1898 3.25611 42.2789 1.55346 38.0142 0.664215C20.9532 -2.88816 4.25292 8.1435 0.709737 25.324C-2.83115 42.5045 8.14077 59.3013 25.2133 62.8652C27.3296 63.3087 29.4688 63.5293 31.631 63.5293C33.7955 63.5293 35.9348 63.3064 38.051 62.8629C40.1673 62.4194 42.2169 61.7623 44.1999 60.8937C46.1829 60.0251 48.0556 58.9636 49.8203 57.7067L49.8777 57.6699L50.0064 57.5665L50.0638 57.532C50.6199 57.0725 50.976 56.4912 51.1277 55.7834C51.1691 55.5881 51.1897 55.3905 51.1897 55.1906C51.192 54.9907 51.1736 54.7931 51.1369 54.5955C51.0978 54.4002 51.0427 54.2095 50.9668 54.0233C50.8933 53.8395 50.8014 53.6626 50.6911 53.4948C50.5831 53.3294 50.459 53.1732 50.3189 53.0307C50.181 52.8882 50.0294 52.7618 49.8639 52.6493C49.7008 52.5367 49.5261 52.4425 49.3446 52.3643C49.1608 52.2839 48.9724 52.2265 48.7794 52.1851Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10475 -10.2294L-12.5344 60.9169L49.0875 73.7592L63.7267 2.61294L2.10475 -10.2294Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 36,
    height: 40
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.589 11.9529H11.8833V50.7763H46.589V11.9529Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 35,
    height: 39
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5364 49.8891C34.9578 50.3325 33.3471 50.5669 31.7088 50.5922C30.0681 50.6152 28.4528 50.4267 26.8604 50.0292L26.1895 49.8431H26.178C25.8264 49.742 25.4772 49.6294 25.1325 49.5076C24.7878 49.3858 24.4478 49.2549 24.11 49.1124C23.7722 48.9722 23.439 48.8206 23.1105 48.6597C22.7796 48.4989 22.4556 48.3289 22.1362 48.1496C21.8168 47.9704 21.5043 47.7797 21.1964 47.5821C20.8862 47.3845 20.5852 47.18 20.2865 46.964C19.9901 46.748 19.7006 46.5251 19.4156 46.293C19.133 46.0609 18.855 45.822 18.5861 45.5738C18.315 45.3257 18.053 45.0706 17.7957 44.8064C17.5406 44.5444 17.2925 44.2733 17.0535 43.9952C16.8122 43.7172 16.5802 43.4346 16.3573 43.1428C16.1321 42.8532 15.9161 42.5545 15.7093 42.2512C15.5025 41.9479 15.3049 41.64 15.1142 41.3252C14.9258 41.0104 14.7442 40.6887 14.5742 40.3647C14.4042 40.0385 14.241 39.7099 14.0894 39.3744C13.9377 39.0389 13.7952 38.7011 13.662 38.3588C13.5287 38.0164 13.4046 37.6694 13.292 37.3202C13.1794 36.9686 13.076 36.6171 12.9818 36.2609C12.8899 35.9047 12.8072 35.5463 12.7337 35.1855C12.6624 34.8248 12.6004 34.4617 12.5476 34.0987C12.4947 33.7333 12.4533 33.368 12.4235 33.0003C12.3913 32.635 12.3706 32.2674 12.3614 31.8997C12.3522 31.5321 12.3522 31.1644 12.3637 30.7968C12.3729 30.4291 12.3959 30.0615 12.4281 29.6938C12.4579 29.3285 12.5016 28.9631 12.5544 28.5978C12.6073 28.2347 12.6693 27.8717 12.7429 27.5109C12.8164 27.1502 12.9014 26.7917 12.9933 26.4356C13.0875 26.0817 13.1909 25.7279 13.3058 25.3786C13.4207 25.0293 13.5448 24.6824 13.6781 24.34C13.8113 23.9976 13.9538 23.6599 14.1077 23.3244C14.2617 22.9912 14.4225 22.6603 14.5949 22.3363C14.7672 22.0123 14.9487 21.693 15.1395 21.3782C15.3279 21.0634 15.5278 20.7555 15.7346 20.4522C15.9437 20.1488 16.1597 19.8524 16.3849 19.5629C16.6077 19.2711 16.8421 18.9885 17.0834 18.7104C17.3223 18.4347 17.5728 18.1636 17.8279 17.9016C18.0852 17.6397 18.3472 17.3846 18.6183 17.1365C18.8894 16.8906 19.1675 16.6493 19.4524 16.4195C19.7373 16.1875 20.0268 15.9646 20.3233 15.7509C20.622 15.5372 20.9253 15.3304 21.2332 15.1328C21.5434 14.9375 21.8559 14.7491 22.1776 14.5698C22.497 14.3906 22.8209 14.2229 23.1495 14.062C23.4804 13.9012 23.8136 13.7518 24.1514 13.6117C24.4891 13.4692 24.8315 13.3405 25.1762 13.2187C25.5208 13.097 25.8701 12.9867 26.2217 12.8856C26.5732 12.7845 26.9271 12.6948 27.2855 12.6144C27.6417 12.534 28.0001 12.4651 28.3609 12.4053C28.7216 12.3456 29.0847 12.295 29.4477 12.2583C29.8108 12.2192 30.1761 12.1893 30.5415 12.1732C30.9068 12.1549 31.2722 12.148 31.6375 12.1526C32.0029 12.1549 32.3682 12.1686 32.7336 12.1939C33.0989 12.2192 33.462 12.2537 33.825 12.2996C34.1881 12.3456 34.5488 12.403 34.9096 12.4697C35.268 12.5363 35.6265 12.6121 35.9803 12.6994C36.3365 12.7868 36.6904 12.8833 37.0396 12.9913C37.3889 13.0992 37.7359 13.2164 38.0782 13.3451C38.4206 13.4715 38.7607 13.6094 39.0961 13.7564C39.4293 13.9058 39.7602 14.062 40.0865 14.2275C40.4128 14.3952 40.7345 14.5698 41.0516 14.756C41.3663 14.9398 41.6765 15.1351 41.9822 15.3373C42.2878 15.5395 42.5865 15.7509 42.8806 15.9715C43.1724 16.1921 43.4596 16.4195 43.74 16.6562C44.018 16.8929 44.2914 17.1388 44.558 17.3915C44.8245 17.6443 45.0819 17.9039 45.3346 18.1705L45.8309 18.7311C45.8976 18.8138 45.955 18.9034 46.0056 18.9977C46.1986 19.3377 46.3273 19.7008 46.3916 20.0868C46.4536 20.4728 46.449 20.8566 46.3755 21.2403C46.302 21.624 46.1641 21.9848 45.9619 22.318C45.7597 22.6511 45.5047 22.9407 45.2013 23.1819C44.8957 23.4232 44.558 23.6047 44.188 23.7242C43.8181 23.846 43.4389 23.8965 43.0506 23.8781C42.6623 23.8621 42.2901 23.777 41.9316 23.6254C41.5731 23.4714 41.2538 23.2623 40.9711 22.9935L40.6701 22.6557C40.1508 22.0997 39.5856 21.5942 38.9767 21.1392C38.3677 20.6842 37.7221 20.289 37.0419 19.9512C36.3618 19.6135 35.6587 19.3377 34.928 19.1286C34.1996 18.9172 33.4574 18.7748 32.7037 18.6989C31.9477 18.6231 31.1918 18.6162 30.4358 18.676C29.6798 18.738 28.9353 18.8644 28.2023 19.062C27.4694 19.2573 26.7593 19.517 26.0723 19.8409C25.3853 20.1649 24.7327 20.5487 24.1146 20.9898C23.4965 21.431 22.922 21.9273 22.3936 22.4719C21.8628 23.0188 21.3848 23.607 20.962 24.2412C20.5369 24.8731 20.1716 25.5371 19.866 26.2357C19.5604 26.9342 19.3191 27.6557 19.1422 28.3979C18.9653 29.1401 18.855 29.8914 18.8136 30.6543C18.7699 31.4172 18.7952 32.1754 18.8894 32.9337C18.9813 33.692 19.1422 34.4342 19.3674 35.1626C19.5949 35.891 19.8844 36.5941 20.2359 37.2696C20.5875 37.9475 20.9965 38.5863 21.4607 39.1883C21.9271 39.7903 22.4418 40.3464 23.0071 40.8565C23.5723 41.3643 24.1789 41.8192 24.8246 42.2168C25.4726 42.6166 26.1481 42.9543 26.8558 43.2324C27.5613 43.5081 28.2874 43.7195 29.0318 43.8666C29.7763 44.0113 30.5277 44.0894 31.286 44.0986C32.0442 44.1078 32.7979 44.0481 33.547 43.9217C34.2938 43.7953 35.0245 43.6023 35.7391 43.3427C37.3177 42.7751 38.7262 41.9203 39.9624 40.7806C39.9739 40.7806 39.9739 40.7806 39.9739 40.7692L40.2404 40.5233C40.3852 40.3992 40.5391 40.2866 40.7046 40.1855C41.0378 39.9902 41.3939 39.8569 41.7731 39.788C42.1522 39.7214 42.5336 39.7214 42.9128 39.7903C43.2942 39.8592 43.6503 39.9925 43.9812 40.1901C44.3144 40.3877 44.6016 40.6359 44.8452 40.9369C45.0888 41.2402 45.2726 41.5734 45.3967 41.941C45.5207 42.3087 45.5782 42.6878 45.569 43.0761C45.5575 43.4645 45.4817 43.839 45.3369 44.1997C45.1922 44.5605 44.9923 44.8845 44.7326 45.1717C44.6223 45.3073 44.4982 45.4268 44.3604 45.5325H44.3489C42.0947 47.6188 39.4914 49.071 36.5364 49.8891Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.41787 20.5157L39.036 -2.01172L62.2229 42.2482L19.7691 64.7734L-3.41787 20.5157Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 26,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9436 25.4815H23.6496V37.2462H48.9436V25.4815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 26,
    height: 12
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9769 30.5871C24.0183 30.2723 24.0872 29.9598 24.1815 29.6565C24.2757 29.3509 24.3951 29.0568 24.5376 28.7719C24.6824 28.4869 24.8478 28.2181 25.0385 27.9608C25.2269 27.7034 25.436 27.4667 25.6658 27.2461C25.8956 27.0256 26.1415 26.8256 26.4034 26.6464C26.6654 26.4672 26.9411 26.3109 27.2306 26.18C27.5201 26.0467 27.8165 25.941 28.1244 25.8583C28.4301 25.7779 28.7426 25.7227 29.0573 25.6951C29.3744 25.6653 29.6892 25.663 30.0063 25.6882C30.3234 25.7135 30.6336 25.7664 30.9415 25.8445C31.2494 25.9226 31.5481 26.026 31.8377 26.1547C32.1295 26.2834 32.4052 26.435 32.6718 26.612C32.936 26.7889 33.1842 26.9842 33.4162 27.2025C33.646 27.4208 33.8574 27.6574 34.0504 27.9125C34.2434 28.1653 34.4112 28.4341 34.5582 28.7167C34.7053 28.9994 34.8271 29.2935 34.9259 29.5968C36.0357 30.2264 37.5637 30.6101 39.2664 30.6101C40.7232 30.6101 42.0674 30.3206 43.1198 29.8426C43.3886 29.3785 43.754 29.0177 44.2204 28.7581C44.4479 28.6248 44.6915 28.5237 44.9488 28.4571C45.1005 28.4203 45.2567 28.3973 45.413 28.3858C45.8427 28.3445 46.2608 28.395 46.6699 28.5375C47.0789 28.68 47.4373 28.9005 47.7498 29.2016H47.7613L47.9819 29.4451C48.0991 29.5784 48.2002 29.7209 48.2829 29.8771C48.3794 30.0494 48.4598 30.2287 48.5196 30.4148C48.5816 30.6032 48.6253 30.7939 48.6505 30.9915C48.6735 31.1868 48.6804 31.3844 48.6643 31.5798C48.6505 31.7774 48.6184 31.9704 48.5655 32.1611C48.5127 32.3518 48.4437 32.5356 48.3541 32.7126C48.2668 32.8872 48.1634 33.0549 48.0416 33.2112C47.9221 33.3651 47.7866 33.5076 47.6395 33.6386C47.4902 33.7673 47.3293 33.8798 47.1593 33.9763C46.617 34.2865 46.0334 34.4129 45.413 34.3509C45.2544 34.3348 45.1005 34.3072 44.9488 34.2682C44.4663 34.1464 44.0435 33.9166 43.6758 33.5811L43.3404 33.2204C43.3404 33.2135 43.3358 33.2089 43.3289 33.2089L43.1198 32.8941C42.0674 32.4047 40.7232 32.1128 39.2664 32.1128C37.5637 32.1128 36.0357 32.4989 34.9259 33.1377C34.8133 33.4685 34.6731 33.7879 34.5031 34.0935C34.3331 34.3968 34.1377 34.6841 33.9149 34.9529C33.692 35.2217 33.4461 35.4676 33.1796 35.6905C32.9107 35.9134 32.6258 36.1087 32.3225 36.2787C32.0192 36.4488 31.7021 36.5889 31.3735 36.7015C31.0426 36.8118 30.7072 36.8922 30.3625 36.9405C30.0178 36.9887 29.6732 37.0048 29.3262 36.991C28.9792 36.975 28.6369 36.9267 28.2968 36.8486C27.959 36.7682 27.6304 36.6602 27.3133 36.52C26.9939 36.3798 26.6906 36.2098 26.4034 36.0145C26.1162 35.8169 25.8496 35.5963 25.6015 35.3504C25.3556 35.1046 25.1327 34.838 24.9351 34.5508C24.7375 34.2636 24.5675 33.9603 24.425 33.6409C24.2826 33.3215 24.17 32.9929 24.0872 32.6528C24.0068 32.3128 23.9563 31.9681 23.9379 31.6188C23.9172 31.2696 23.931 30.9226 23.9769 30.5756V30.5871Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6603 20.7168L50.9163 36.5393L24.9375 41.9552L21.6793 26.1303L47.6603 20.7168Z",
    fill: "black"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.276 37.364V21.656C73.276 17.232 75.474 15.02 79.87 15.02H91.546L93.688 16.7V18.884H79.912C78.316 18.884 77.518 19.668 77.518 21.236V37.784C77.518 39.352 78.316 40.136 79.912 40.136H93.688V42.32L91.546 44H79.87C75.474 44 73.276 41.788 73.276 37.364ZM98.7388 37.532V28.502C98.7388 24.218 100.881 22.076 105.165 22.076H111.045C115.329 22.076 117.471 24.218 117.471 28.502V37.532C117.471 41.844 115.329 44 111.045 44H105.165C100.881 44 98.7388 41.844 98.7388 37.532ZM102.813 37.952C102.813 39.604 103.639 40.43 105.291 40.43H110.961C112.585 40.43 113.397 39.604 113.397 37.952V28.082C113.397 26.458 112.585 25.646 110.961 25.646H105.291C103.639 25.646 102.813 26.458 102.813 28.082V37.952ZM123.348 37.532V28.502C123.348 24.218 125.49 22.076 129.774 22.076H137.586V12.92H141.66V44H129.774C125.49 44 123.348 41.844 123.348 37.532ZM127.422 37.952C127.422 39.604 128.248 40.43 129.9 40.43H137.586V25.646H129.9C128.248 25.646 127.422 26.458 127.422 28.082V37.952ZM172.411 44V19.388C172.411 15.076 174.553 12.92 178.837 12.92H182.743L184.675 14.348V16.49H178.963C177.311 16.49 176.485 17.316 176.485 18.968V22.076H184.255V25.646H176.485V44H172.411ZM188.776 44V19.388C188.776 15.076 190.918 12.92 195.202 12.92H199.108L201.04 14.348V16.49H195.328C193.676 16.49 192.85 17.316 192.85 18.968V22.076H200.62V25.646H192.85V44H188.776ZM204.973 18.128V13.676H209.341V18.128H204.973ZM205.141 44V22.076H209.215V44H205.141Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.876 37.532V28.502C147.876 24.218 150.018 22.076 154.302 22.076H159.762C164.046 22.076 166.188 24.218 166.188 28.502V34.55H151.95V37.952C151.95 39.604 152.776 40.43 154.428 40.43H165.348V42.572L163.458 44H154.302C150.018 44 147.876 41.844 147.876 37.532ZM151.95 31.358H162.114V28.082C162.114 26.458 161.302 25.646 159.678 25.646H154.428C152.776 25.646 151.95 26.458 151.95 28.082V31.358Z",
    fill: "#0047FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 13,
    width: 7,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9424 13.7178H59.9993V20.1883H53.9424V13.7178Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 13,
    width: 7,
    height: 7
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6908 14.0388C57.3806 13.9606 57.0658 13.9354 56.7464 13.9583C56.427 13.9836 56.1191 14.0571 55.8227 14.1812C55.5286 14.3053 55.2597 14.473 55.0162 14.6821C54.7726 14.8935 54.5704 15.1371 54.4049 15.4128C54.359 15.5185 54.3015 15.6104 54.2533 15.7047C54.1729 15.8678 54.1154 16.0378 54.081 16.2171C54.0327 16.4078 54.0051 16.6008 53.9936 16.7984C53.9845 16.996 53.9936 17.1913 54.0235 17.3866C54.0511 17.5819 54.097 17.7727 54.1637 17.9565C54.2303 18.1426 54.313 18.3218 54.4141 18.4896C54.5129 18.6596 54.6301 18.8159 54.7611 18.9629C54.8921 19.11 55.0368 19.2409 55.1931 19.3604C55.3516 19.4776 55.5171 19.5787 55.694 19.6637C55.8709 19.7465 56.0548 19.8131 56.2455 19.8613C56.5511 19.9372 56.859 19.9624 57.1738 19.9395C57.4863 19.9165 57.7896 19.8453 58.0814 19.7281C58.3709 19.6086 58.6375 19.45 58.881 19.2478C59.1223 19.0456 59.3291 18.8113 59.4968 18.547L59.7174 18.1035H59.7289C59.7864 17.9634 59.8346 17.8209 59.8668 17.6716C59.9127 17.4808 59.9403 17.2878 59.9495 17.0902C59.9587 16.8949 59.9472 16.6996 59.9173 16.5043C59.8875 16.309 59.8392 16.1206 59.7726 15.9344C59.7059 15.7506 59.6232 15.5737 59.5221 15.4059C59.421 15.2359 59.3038 15.0797 59.1728 14.9349C59.0419 14.7878 58.8971 14.6569 58.7409 14.5397C58.5846 14.4225 58.4169 14.3214 58.2399 14.2364C58.0653 14.1537 57.8815 14.087 57.6908 14.0388Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2301 12.7393L52.7939 19.713L59.7126 21.1537L61.1464 14.1823L54.2301 12.7393Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 44,
    width: 7,
    height: 7
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3545 44.3047H59.825V50.7752H53.3545V44.3047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 44,
    width: 7,
    height: 7
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4824 44.6598C57.1699 44.5817 56.8551 44.5564 56.5357 44.5817C56.2163 44.6047 55.9084 44.6782 55.6143 44.8023C55.3179 44.9264 55.049 45.0941 54.8055 45.3032C54.5642 45.5146 54.3597 45.7582 54.1942 46.0339L54.0334 46.3257C53.9622 46.4912 53.9047 46.6635 53.8588 46.8381C53.7715 47.1851 53.7462 47.5367 53.7829 47.8928C53.822 48.2513 53.9185 48.589 54.0771 48.9107C54.2356 49.2324 54.4424 49.515 54.7021 49.7609C54.9617 50.0091 55.2535 50.2021 55.5821 50.3423C55.9107 50.4824 56.2508 50.5628 56.6069 50.5789C56.9631 50.5973 57.31 50.5513 57.6501 50.4434C57.9902 50.3354 58.3004 50.1722 58.583 49.9539C58.8633 49.7333 59.1 49.4714 59.2884 49.1681C59.3689 49.0279 59.4378 48.8763 59.5067 48.7361H59.5182C59.5757 48.5959 59.6124 48.4581 59.6584 48.3064C59.7043 48.1134 59.7319 47.9204 59.7411 47.7228C59.7503 47.5252 59.7411 47.3299 59.7112 47.1345C59.6814 46.9392 59.6331 46.7485 59.5688 46.5624C59.5021 46.3786 59.4171 46.1993 59.316 46.0316C59.2149 45.8616 59.1 45.7053 58.9667 45.5583C58.8358 45.4112 58.691 45.2802 58.5348 45.163C58.3762 45.0459 58.2108 44.9448 58.0315 44.8597C57.8546 44.7747 57.6708 44.7081 57.4824 44.6598Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9921 43.3574L52.5537 50.3496L59.5045 51.7972L60.9429 44.805L53.9921 43.3574Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 64
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H51.5898V63.5291H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 52,
    height: 65
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7796 52.185C48.3637 52.0977 47.9478 52.1 47.5319 52.1919C47.116 52.2838 46.7369 52.4561 46.3945 52.7089C45.2341 53.5407 44.0117 54.2691 42.7295 54.8941C41.4474 55.5191 40.1216 56.0315 38.7521 56.4313C37.3849 56.8334 35.9924 57.116 34.577 57.2792C33.1616 57.4446 31.7415 57.4906 30.3169 57.4147L29.9125 57.3918C28.7452 57.3113 27.5871 57.1528 26.4406 56.9138C12.6332 54.037 3.76603 40.4433 6.62447 26.5578C9.48292 12.6746 22.9916 3.73853 36.7875 6.61765C40.1675 7.31617 43.2764 8.65119 46.1165 10.6227H46.128C46.298 10.7812 46.4818 10.9191 46.684 11.0317C46.9552 11.1764 47.2401 11.2821 47.5411 11.3465C47.8743 11.4131 48.2098 11.4223 48.5475 11.3764C48.8853 11.3281 49.207 11.227 49.5103 11.0708C49.8136 10.9168 50.0847 10.7146 50.3191 10.4664C50.5558 10.2183 50.7465 9.94024 50.889 9.62774C51.0291 9.31754 51.1187 8.99126 51.1509 8.64889C51.1831 8.30652 51.1601 7.97104 51.0797 7.63557C51.0016 7.30239 50.8683 6.99219 50.6845 6.70267C50.5006 6.41544 50.2732 6.16499 50.0066 5.95359H49.9951L49.7975 5.81342L49.7516 5.77896C46.19 3.25599 42.2792 1.55333 38.0145 0.664092C20.9534 -2.88828 4.25316 8.14338 0.70998 25.3239C-2.8309 42.5044 8.14101 59.3012 25.2135 62.8651C27.3298 63.3086 29.469 63.5291 31.6312 63.5291C33.7958 63.5291 35.935 63.3063 38.0513 62.8628C40.1675 62.4193 42.2171 61.7621 44.2001 60.8936C46.1831 60.025 48.0558 58.9634 49.8205 57.7066L49.8779 57.6698L50.0066 57.5664L50.0641 57.5319C50.6201 57.0724 50.9763 56.491 51.1279 55.7833C51.1693 55.588 51.19 55.3904 51.19 55.1905C51.1923 54.9906 51.1739 54.793 51.1371 54.5954C51.0981 54.4 51.0429 54.2093 50.9671 54.0232C50.8936 53.8394 50.8017 53.6625 50.6914 53.4947C50.5834 53.3293 50.4593 53.173 50.3191 53.0306C50.1812 52.8881 50.0296 52.7617 49.8642 52.6491C49.701 52.5365 49.5264 52.4423 49.3449 52.3642C49.161 52.2838 48.9726 52.2263 48.7796 52.185Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10502 -10.2295L-12.5342 60.9168L49.0878 73.7591L63.7269 2.61283L2.10502 -10.2295Z",
    fill: "url(#paint0_linear_78_2)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 36,
    height: 40
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5886 11.9531H11.8828V50.7765H46.5886V11.9531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 35,
    height: 39
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.536 49.8892C34.9574 50.3327 33.3467 50.5671 31.7083 50.5924C30.0677 50.6153 28.4524 50.4269 26.86 50.0294L26.1891 49.8433H26.1776C25.826 49.7422 25.4768 49.6296 25.1321 49.5078C24.7874 49.386 24.4474 49.255 24.1096 49.1126C23.7718 48.9724 23.4386 48.8208 23.11 48.6599C22.7792 48.4991 22.4552 48.329 22.1358 48.1498C21.8164 47.9706 21.5039 47.7799 21.196 47.5823C20.8858 47.3847 20.5848 47.1801 20.2861 46.9642C19.9897 46.7482 19.7001 46.5253 19.4152 46.2932C19.1326 46.0611 18.8545 45.8222 18.5857 45.574C18.3146 45.3258 18.0526 45.0708 17.7953 44.8065C17.5402 44.5446 17.2921 44.2735 17.0531 43.9954C16.8118 43.7174 16.5797 43.4348 16.3569 43.1429C16.1317 42.8534 15.9157 42.5547 15.7089 42.2514C15.5021 41.9481 15.3045 41.6402 15.1138 41.3254C14.9253 41.0106 14.7438 40.6889 14.5738 40.3649C14.4037 40.0386 14.2406 39.7101 14.0889 39.3746C13.9373 39.0391 13.7948 38.7013 13.6616 38.359C13.5283 38.0166 13.4042 37.6696 13.2916 37.3204C13.179 36.9688 13.0756 36.6172 12.9814 36.2611C12.8895 35.9049 12.8068 35.5465 12.7333 35.1857C12.662 34.825 12.6 34.4619 12.5471 34.0989C12.4943 33.7335 12.4529 33.3682 12.4231 33.0005C12.3909 32.6352 12.3702 32.2675 12.361 31.8999C12.3518 31.5322 12.3518 31.1646 12.3633 30.797C12.3725 30.4293 12.3955 30.0617 12.4276 29.694C12.4575 29.3287 12.5012 28.9633 12.554 28.598C12.6069 28.2349 12.6689 27.8719 12.7424 27.5111C12.816 27.1504 12.901 26.7919 12.9929 26.4358C13.0871 26.0819 13.1905 25.728 13.3054 25.3788C13.4203 25.0295 13.5444 24.6826 13.6776 24.3402C13.8109 23.9978 13.9534 23.66 14.1073 23.3246C14.2613 22.9914 14.4221 22.6605 14.5945 22.3365C14.7668 22.0125 14.9483 21.6931 15.139 21.3783C15.3274 21.0635 15.5274 20.7556 15.7342 20.4523C15.9433 20.149 16.1592 19.8526 16.3844 19.5631C16.6073 19.2713 16.8417 18.9887 17.083 18.7106C17.3219 18.4349 17.5724 18.1637 17.8274 17.9018C18.0848 17.6399 18.3467 17.3848 18.6179 17.1366C18.889 16.8908 19.167 16.6495 19.452 16.4197C19.7369 16.1877 20.0264 15.9648 20.3228 15.7511C20.6215 15.5374 20.9248 15.3306 21.2328 15.133C21.543 14.9377 21.8555 14.7492 22.1771 14.57C22.4965 14.3908 22.8205 14.223 23.1491 14.0622C23.48 13.9014 23.8132 13.752 24.1509 13.6118C24.4887 13.4694 24.8311 13.3407 25.1757 13.2189C25.5204 13.0971 25.8697 12.9868 26.2212 12.8857C26.5728 12.7846 26.9267 12.695 27.2851 12.6146C27.6413 12.5342 27.9997 12.4652 28.3605 12.4055C28.7212 12.3458 29.0843 12.2952 29.4473 12.2584C29.8104 12.2194 30.1757 12.1895 30.5411 12.1734C30.9064 12.155 31.2718 12.1482 31.6371 12.1527C32.0025 12.155 32.3678 12.1688 32.7332 12.1941C33.0985 12.2194 33.4616 12.2538 33.8246 12.2998C34.1877 12.3458 34.5484 12.4032 34.9092 12.4698C35.2676 12.5365 35.6261 12.6123 35.9799 12.6996C36.3361 12.7869 36.6899 12.8834 37.0392 12.9914C37.3885 13.0994 37.7354 13.2166 38.0778 13.3453C38.4202 13.4717 38.7602 13.6095 39.0957 13.7566C39.4289 13.906 39.7598 14.0622 40.0861 14.2276C40.4123 14.3954 40.734 14.57 41.0511 14.7561C41.3659 14.94 41.6761 15.1353 41.9817 15.3375C42.2873 15.5397 42.586 15.7511 42.8802 15.9717C43.172 16.1922 43.4592 16.4197 43.7395 16.6564C44.0176 16.8931 44.291 17.1389 44.5575 17.3917C44.8241 17.6444 45.0814 17.9041 45.3342 18.1706L45.8305 18.7313C45.8972 18.814 45.9546 18.9036 46.0052 18.9978C46.1982 19.3379 46.3268 19.701 46.3912 20.087C46.4532 20.473 46.4486 20.8567 46.3751 21.2405C46.3016 21.6242 46.1637 21.985 45.9615 22.3181C45.7593 22.6513 45.5042 22.9408 45.2009 23.1821C44.8953 23.4234 44.5575 23.6049 44.1876 23.7244C43.8177 23.8462 43.4385 23.8967 43.0502 23.8783C42.6619 23.8622 42.2896 23.7772 41.9312 23.6256C41.5727 23.4716 41.2533 23.2625 40.9707 22.9937L40.6697 22.6559C40.1504 22.0998 39.5851 21.5943 38.9762 21.1394C38.3673 20.6844 37.7216 20.2892 37.0415 19.9514C36.3614 19.6136 35.6582 19.3379 34.9275 19.1288C34.1991 18.9174 33.457 18.775 32.7033 18.6991C31.9473 18.6233 31.1913 18.6164 30.4354 18.6762C29.6794 18.7382 28.9349 18.8646 28.2019 19.0622C27.4689 19.2575 26.7589 19.5171 26.0719 19.8411C25.3848 20.1651 24.7323 20.5488 24.1142 20.99C23.4961 21.4312 22.9216 21.9275 22.3931 22.4721C21.8623 23.019 21.3844 23.6072 20.9616 24.2414C20.5365 24.8733 20.1712 25.5373 19.8656 26.2359C19.56 26.9344 19.3187 27.6559 19.1418 28.3981C18.9648 29.1403 18.8545 29.8916 18.8132 30.6545C18.7695 31.4174 18.7948 32.1756 18.889 32.9339C18.9809 33.6922 19.1418 34.4343 19.367 35.1627C19.5944 35.8911 19.884 36.5943 20.2355 37.2698C20.5871 37.9477 20.9961 38.5864 21.4602 39.1885C21.9267 39.7905 22.4414 40.3465 23.0066 40.8567C23.5719 41.3645 24.1785 41.8194 24.8242 42.2169C25.4722 42.6168 26.1477 42.9545 26.8554 43.2326C27.5608 43.5083 28.2869 43.7197 29.0314 43.8667C29.7759 44.0115 30.5273 44.0896 31.2856 44.0988C32.0438 44.108 32.7975 44.0483 33.5466 43.9219C34.2933 43.7955 35.024 43.6025 35.7387 43.3429C37.3172 42.7753 38.7258 41.9205 39.962 40.7808C39.9735 40.7808 39.9735 40.7808 39.9735 40.7693L40.24 40.5235C40.3848 40.3994 40.5387 40.2868 40.7042 40.1857C41.0373 39.9904 41.3935 39.8571 41.7726 39.7882C42.1518 39.7215 42.5332 39.7215 42.9123 39.7905C43.2938 39.8594 43.6499 39.9927 43.9808 40.1903C44.314 40.3879 44.6012 40.6361 44.8448 40.9371C45.0883 41.2404 45.2722 41.5736 45.3962 41.9412C45.5203 42.3088 45.5778 42.688 45.5686 43.0763C45.5571 43.4646 45.4813 43.8392 45.3365 44.1999C45.1917 44.5607 44.9918 44.8847 44.7322 45.1719C44.6219 45.3075 44.4978 45.4269 44.3599 45.5326H44.3484C42.0943 47.619 39.4909 49.0712 36.536 49.8892Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.41846 20.5157L39.0354 -2.01169L62.2224 42.2482L19.7685 64.7734L-3.41846 20.5157Z",
    fill: "url(#paint1_linear_78_2)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 26,
    height: 13
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9434 25.4814H23.6494V37.2461H48.9434V25.4814Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_78_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_78_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 26,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9767 30.5872C24.0181 30.2725 24.087 29.96 24.1812 29.6566C24.2754 29.351 24.3949 29.0569 24.5374 28.772C24.6821 28.4871 24.8476 28.2182 25.0383 27.9609C25.2267 27.7035 25.4358 27.4669 25.6656 27.2463C25.8954 27.0257 26.1412 26.8258 26.4032 26.6466C26.6651 26.4673 26.9408 26.3111 27.2304 26.1801C27.5199 26.0468 27.8163 25.9411 28.1242 25.8584C28.4298 25.778 28.7423 25.7228 29.0571 25.6953C29.3742 25.6654 29.689 25.6631 30.0061 25.6884C30.3232 25.7137 30.6334 25.7665 30.9413 25.8446C31.2492 25.9227 31.5479 26.0261 31.8374 26.1548C32.1292 26.2835 32.405 26.4352 32.6715 26.6121C32.9358 26.789 33.1839 26.9843 33.416 27.2026C33.6458 27.4209 33.8572 27.6576 34.0502 27.9126C34.2432 28.1654 34.4109 28.4342 34.558 28.7169C34.7051 28.9995 34.8268 29.2936 34.9256 29.5969C36.0355 30.2265 37.5635 30.6102 39.2662 30.6102C40.7229 30.6102 42.0672 30.3207 43.1195 29.8428C43.3884 29.3786 43.7537 29.0179 44.2202 28.7582C44.4477 28.6249 44.6912 28.5238 44.9486 28.4572C45.1002 28.4204 45.2565 28.3975 45.4127 28.386C45.8424 28.3446 46.2606 28.3952 46.6696 28.5376C47.0786 28.6801 47.4371 28.9007 47.7496 29.2017H47.7611L47.9816 29.4453C48.0988 29.5785 48.1999 29.721 48.2827 29.8772C48.3792 30.0496 48.4596 30.2288 48.5193 30.4149C48.5814 30.6033 48.625 30.794 48.6503 30.9917C48.6733 31.187 48.6802 31.3846 48.6641 31.5799C48.6503 31.7775 48.6181 31.9705 48.5653 32.1612C48.5124 32.3519 48.4435 32.5358 48.3539 32.7127C48.2666 32.8873 48.1632 33.0551 48.0414 33.2113C47.9219 33.3653 47.7863 33.5077 47.6393 33.6387C47.4899 33.7674 47.3291 33.88 47.159 33.9765C46.6168 34.2867 46.0331 34.4131 45.4127 34.351C45.2542 34.3349 45.1002 34.3074 44.9486 34.2683C44.466 34.1465 44.0432 33.9167 43.6756 33.5813L43.3401 33.2205C43.3401 33.2136 43.3355 33.209 43.3286 33.209L43.1195 32.8942C42.0672 32.4048 40.7229 32.113 39.2662 32.113C37.5635 32.113 36.0355 32.499 34.9256 33.1378C34.813 33.4687 34.6729 33.7881 34.5028 34.0937C34.3328 34.397 34.1375 34.6842 33.9146 34.953C33.6917 35.2219 33.4459 35.4677 33.1793 35.6906C32.9105 35.9135 32.6256 36.1088 32.3223 36.2789C32.0189 36.4489 31.7019 36.5891 31.3733 36.7016C31.0424 36.8119 30.7069 36.8924 30.3622 36.9406C30.0176 36.9889 29.6729 37.005 29.3259 36.9912C28.979 36.9751 28.6366 36.9268 28.2965 36.8487C27.9588 36.7683 27.6302 36.6603 27.3131 36.5201C26.9937 36.38 26.6904 36.2099 26.4032 36.0146C26.1159 35.817 25.8494 35.5964 25.6012 35.3506C25.3554 35.1047 25.1325 34.8381 24.9349 34.5509C24.7373 34.2637 24.5672 33.9604 24.4248 33.641C24.2823 33.3216 24.1697 32.993 24.087 32.653C24.0066 32.3129 23.956 31.9682 23.9376 31.619C23.917 31.2697 23.9307 30.9227 23.9767 30.5758V30.5872Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_78_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6601 20.7169L50.916 36.5394L24.9373 41.9553L21.679 26.1305L47.6601 20.7169Z",
    fill: "#2771E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_2",
    x1: 13.6498,
    y1: -14.0717,
    x2: 43.5012,
    y2: 75.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_2",
    x1: 8.27531,
    y1: 44.8502,
    x2: 51.6383,
    y2: 19.8356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiffiLogo);
export default __webpack_public_path__ + "static/media/codiffi-logo.768a9108bf544bfcd46a008ea62f48a8.svg";
export { ForwardRef as ReactComponent };